/**
 * @Author : ShaJiaJing
 * @Date : 2019/5/30
 * @Version : 1.0
 * @Content : 通用接口
 */
import BaseApi from './api'
import { cookie } from '@/utils/util'

const baseOptions = {
  // baseURL: process.env.VUE_APP_PAYURL + '/console/v1',
  baseURL: process.env.VUE_APP_BASEURL,
  headers: {
    'lang': cookie.get('language')
  }
}
const fetch = new BaseApi(baseOptions)
export default fetch
